import React from 'react';

// Import visual assets
import imgVisaStamping from '../../assets/images/image (2)add.png';
import imgDocAttest from '../../assets/images/image (3)add.png';
import imgCareerConsult from '../../assets/images/image (4)add.png';
import imgInterviewCoaching from '../../assets/images/image (5)add.png';
import imgResumePrep from '../../assets/images/image (6)add.png';

const OurAdditionalServices = ({ data }: { data?: any }) => {
  const cards = data?.cards || [];
  const imageCards = cards.length > 0 ? cards.slice(0, 5) : [
    { title: "Visa Stamping Solutions", image_url: imgVisaStamping },
    { title: "Document Attestation", image_url: imgDocAttest },
    { title: "Career Consulting", image_url: imgCareerConsult },
    { title: "Resume Preparation", image_url: imgResumePrep },
    { title: "Interview Coaching", image_url: imgInterviewCoaching }
  ];
  const ctaCard = cards.length > 5 ? cards[5] : {
    title: "Explore Other solutions we offer",
    cta_text: "KNOW MORE",
    cta_link: "/ourcoreservices"
  };

  return (
    <section className="bg-[#EAF0F6] py-16 md:py-24 font-manrope">
      <div className="max-w-7xl mx-auto px-4 md:px-10 lg:px-8">
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 items-stretch">
          
          {/* Top Left Content Block (Spans 2 Columns on Large Screens) */}
          <div className="sm:col-span-2 flex flex-col justify-center pr-4 mb-6 lg:mb-0">
            {data?.title ? (
              <div dangerouslySetInnerHTML={{ __html: data.title }} className="mb-6" />
            ) : (
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.15] mb-6">
                <span className="text-[#c1272d] block">Our Additional</span>
                <span className="text-[#0a1e3f] block mt-1">Services</span>
              </h2>
            )}
            <p className="text-[#5e6d7c] text-base md:text-lg leading-relaxed font-medium max-w-lg">
              {data?.description || "Discover a wide range of value-added services, from document attestation to premium visa support, designed to make your overseas journey smoother, faster, and completely hassle-free."}
            </p>
          </div>

          {/* Dynamic Image Cards */}
          {imageCards.map((card: any, index: number) => (
            <div 
              key={index} 
              className={`relative ${index < 2 ? 'h-72 sm:h-80 lg:h-auto min-h-[260px]' : 'h-72 sm:h-80'} rounded-[24px] overflow-hidden group cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300`}
            >
              <img 
                src={card.image_url || card.flag_image_url} 
                alt={card.title} 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(109,242,167,0)_45.47%,#302D48_100%)]"></div>
              <h3 className="absolute bottom-6 left-6 text-white font-extrabold text-lg md:text-xl leading-snug pr-6">
                <span dangerouslySetInnerHTML={{ __html: (card.title || '').replace('&', '&amp;').replace('\n', '<br/>') }} />
              </h3>
            </div>
          ))}

          {/* CTA Box Block */}
          <div className="bg-[#2e6cb2] h-72 sm:h-80 rounded-[24px] p-8 flex flex-col justify-between shadow-sm hover:shadow-lg transition-all duration-300">
            <h3 className="text-white text-2xl md:text-[26px] font-bold leading-[1.3] tracking-tight pr-2">
              {ctaCard.title}
            </h3>
            <div>
              <button 
                onClick={() => window.location.href = ctaCard.cta_link || ctaCard.link || '/ourcoreservices'}
                className="bg-[#c1272d] hover:bg-red-700 text-white text-xs tracking-widest font-bold py-3.5 px-6 shadow-md transition-all active:scale-95 uppercase whitespace-nowrap"
              >
                {ctaCard.cta_text || ctaCard.text || "KNOW MORE"}
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurAdditionalServices;
